import React from "react";
import { Form } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { labelOf } from "./model.tsx";
import { FieldSpec } from "./resources.tsx";

interface FieldInputProps {
  scope: string;
  field: FieldSpec;
  value: string;
  errors?: string[];
  list?: string;
  onChange: (value: string) => void;
}

const FieldInput: React.FC<FieldInputProps> = ({ scope, field, value, errors, list, onChange }) => {
  const { t } = useTranslation();
  const numeric = field.kind === "number" || field.kind === "integer";

  return (
    <Form.Group className="mb-3" controlId={`${scope}-${field.name}`}>
      <Form.Label>{labelOf(field, t)}</Form.Label>
      <Form.Control
        type={numeric ? "number" : "text"}
        step={field.kind === "number" ? "any" : undefined}
        min={field.min}
        maxLength={field.maxLength}
        required={field.required}
        list={list}
        value={value}
        isInvalid={Boolean(errors?.length)}
        onChange={(event) => onChange(event.target.value)}
      />
      {field.kind === "integers" && <Form.Text>{t("catalog.form.integersHint")}</Form.Text>}
      <Form.Control.Feedback type="invalid">{errors?.join(" ")}</Form.Control.Feedback>
    </Form.Group>
  );
};

export default FieldInput;
